
import React from "react";
import KnowledgeBase from "@/components/feedback/knowledge/KnowledgeBase";

interface HelpTabProps {
  companyId: string;
}

const HelpTab = ({ companyId }: HelpTabProps) => {
  return (
    <div className="h-full p-5 knowledge-base-content overflow-y-auto">
      <KnowledgeBase
        companyId={companyId}
        isEmbedded={true}
        dontAutoSelectArticle={true}
      />
    </div>
  );
};

export default HelpTab;
